"use client";

import dynamic from "next/dynamic";

export const AnimationCompleted = dynamic(
    () => import("./CompletedBrowser")
        // this part is needed if your use a named export
        // you can replace by ".default" when using a default export
        .then((mod) => mod.CompletedBrowser),
    {
        // This prevents server-side rendering of BrowserComponent
        ssr: false,
    }
);